import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { selectIsLogged } from "store/reducer/appReducer";
import AppWrapper from "./components/AppWrapper";
import * as Routes from "./routes/index";

export default function App() {
  const loggedIn = useSelector(selectIsLogged);
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const isAuthPath = path === '/login' || path === '/admin/login' || path.startsWith('/forgot-password') || path.startsWith('/change-password');
  
  return (
    <BrowserRouter>
      {(!loggedIn || isAuthPath) ? (
        // Always render auth routes on explicit auth paths to avoid loops
        <Routes.Render.AuthRoute />
      ) : (
        <AppWrapper>
          <Routes.Render.PrivateRoute />
        </AppWrapper>
      )}
    </BrowserRouter>
  );
}
